export default __webpack_public_path__ + "static/media/PRAZOHECT-2.5.ac382b67.jpg";